import axios from 'axios';
import Layout from '../shared/Layout';
import Form from '../shared/Form';
import { useContext, useEffect, useState } from 'react';
import DetailsContext from '../../providers/DetailsContext';
import ActivityList from '../../components/settings/ActivityList';
import language from '../../variables/language';
import { useLocation, Link  } from 'react-router-dom';

import Header from '../shared/Header';
import ModalUpdate from '../shared/ModalUpdate';


const Users = () => {
  const [modalState ,setModalState] = useState('none');
  const [headers, setHeaders] = useState(
    {'firstName':{}, 'lastName':{}, 'email':{},'tel':{},'dateBirth':{},'position':{},'project':{},'icons':{
      'icon-delete':{'name':'icon-delete','type' : 'icon','url':'/api/users','value' : '','mode':'delete'},
      'icon-edit':{'name':'icon-edit','type' : 'icon','url':'/api/users','value' : '','mode':'edit'},
    }}
    );
  const [inputs, setInputs] = useState(
    {'firstName':{'name':'firstName','type' : 'text','value' : ''},
     'lastName':{'name':'lastName','type' : 'text','value' : ''},
     'email':{'name':'email','type' : 'text','value' : ''},
    'tel':{'name':'tel','type' : 'text','value' : ''},
    'dateBirth':{'name':'dateBirth','type' : 'date','value' : ''},
    'position':{'name':'position','type' : 'text','value' : ''}
});
  const [selectors, setSelectors] = useState({
    'project':{'name':'project','type' : 'number','url':'/api/projects','value' : ''},
    'language':{'name':'language','type' : 'number','url':'/api/languages','value' : ''},
  });
  const [inputsToUpdate, setInputsToUpdate] = useState(
    {'firstName':{'name':'firstName','type' : 'text','value' : ''},
     'lastName':{'name':'lastName','type' : 'text','value' : ''},
     'email':{'name':'email','type' : 'text','value' : ''},
    'tel':{'name':'tel','type' : 'text','value' : ''},
    'dateBirth':{'name':'dateBirth','type' : 'date','value' : ''},
    'position':{'name':'position','type' : 'text','value' : ''}
});
  const [selectorsToUpdate, setSelectorsToUpdate] = useState({
    'project':{'name':'project','type' : 'number','url':'/api/projects','value' : ''},
    'language':{'name':'language','type' : 'number','url':'/api/languages','value' : ''},
  });
  const [icons, setIcons] = useState({
    'icon-delete':{'name':'icon-delete','type' : 'icon','url':'/api/users','value' : ''},
    'icon-edit':{'name':'icon-edit','type' : 'icon','url':'/api/languages','value' : ''},
  });
  const [closerForm, setCloserForm] = useState(0);
  // const API_URL = process.env.REACT_APP_API_URL;
  // const moduleName = 'firmy';
  const label = 'users';
  const location = useLocation();
  const formDoneHundler = () => {
    setCloserForm('0px');
  }
  const [toUpdateId , setToUpdateId] = useState('');
  const onRefreshHundler = ()=> {
    if(closerForm==="1px"){
      setCloserForm('0px');
    }else{
      setCloserForm('1px');
    }
    
  }
  const stateHundler = (state,id) => {
    if(state === 'edit'){
      setModalState('edit');
      setToUpdateId(id);
    }else if(state === 'none'){
      setModalState('none');
    }
  }
 // const { setTheme } = useContext(DetailsContext);


  return (
    <Layout>
      <Header name={language[language.lang][(location.pathname.replace("/",""))]}   opened='300px' >
        <Form inputs={inputs} selectors={selectors} url='/api/users' onRefreshHundler={onRefreshHundler} name='Tutaj możesz dodać nowego uzytkownika'></Form>
      </Header>
      <main className='main-block' >
        <div className='main-content txt-c' >
        <ActivityList name='' url='/api/users' done={closerForm} stateHundler={stateHundler} onRefreshHundler={onRefreshHundler} headers={headers}/>
        </div>  
        <ModalUpdate modalState={modalState} inputs={inputsToUpdate} selectors={selectorsToUpdate} url='/api/users' toUpdate={'/api/users/'+ toUpdateId } done={formDoneHundler} onRefreshHundler={onRefreshHundler} stateHundler={stateHundler} name={language[language.lang].modals[label].updateDescription} title={language[language.lang].modals[label].updateTitle} />
      </main>

    </Layout>
  )
}

export default Users